import {
  ConsignmentAndReturnResponse,
  Resume,
  ReturnRequestListResponse,
} from 'types';

import { priceFactory } from '../price';

export function resumeFactory(params: any = {}): Resume {
  const { quantity, totalPrice } = params;

  return {
    quantity: quantity || 0,
    totalPrice: priceFactory(totalPrice),
  };
}

export function returnRequestListFactory(
  params: any = {}
): ReturnRequestListResponse {
  const { results, pagination, sorts } = params;

  return {
    results: results || [],
    pagination: {
      count: pagination?.count || 0,
      totalCount: pagination?.totalCount || 0,
      page: pagination?.page || 0,
      totalPages: pagination?.totalPages || 0,
      hasNext: pagination?.hasNext || false,
      hasPrevious: pagination?.hasPrevious || false,
    },
    sorts: sorts || [],
  };
}

export function consignmentAndReturnFactory(
  data: any = {}
): ConsignmentAndReturnResponse {
  return {
    consignments: data.consignments || [],
    createdDate: data.createdDate || 0,
    modifiedDate: data.modifiedDate || 0,
    installments: data.installments || 0,
    orderCode: data.orderCode || '',
    paymentMethod: data.paymentMethod || '',
    returnRequests: data.returnRequests || [],
    totalPrice: priceFactory(data.totalPrice),
  };
}
